<template>
  <div style="display:inline-block; vertical-align: middle">
    <el-date-picker
      v-model="time"
      type="daterange"
      align="right"
      unlink-panels
      value-format="yyyy-MM-dd"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :default-value="newDateDate"
      :picker-options="pickerOptions"
      @change="onTimeChange(time)"
    ></el-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: [],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > new Date();
        },
        shortcuts: [
          {
            text: '近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    newDateDate() {
      return (new Date() - 3600 * 1000 * 24 * 30);
    }
  },
  methods: {
    onTimeChange(date) {
      this.$emit('timeChange', date);
    },
    initializeTime() {
      this.time = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input__inner {
  height: 26px;
  line-height: 26px;
  border-radius: 2px;
  border: 1px solid #f7f8fc;
  background-color: #f7f8fc;
  &:hover {
    border: 1px solid #d1d2da;
  }
  &:focus {
    border: 1px solid #747990;
  }
}
.el-range-editor.el-input__inner {
  padding: 0 10px;
}
/deep/.el-range-editor {
  input {
    color: #464d6c;
  }
  input::-webkit-input-placeholder {
    color: #9ea1b4;
    font-weight: 400 !important;
  }
  input::-moz-placeholder {
    color: #9ea1b4;
    font-weight: 400 !important;
  }
  input::-ms-input-placeholder {
    color: #9ea1b4;
    font-weight: 400 !important;
  }
}
/deep/.el-range-editor .el-range__icon {
  line-height: 26px;
} 
/deep/.el-date-editor .el-range__close-icon {
  line-height: 26px;
} 
/deep/.el-date-editor .el-range-separator {
  line-height: 26px;
} 
/deep/.el-date-editor .el-range-input {
  background-color: #f7f7fa;
  border: none !important;
}
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 254px;
}
</style>
